<template>
  <div class="case-slider-container">
    <!-- 轮播主体 -->
    <div class="case-slider" ref="slider">
      <div
          v-for="(item, index) in caseList"
          :key="index"
          class="case-item"
          :class="{ active: currentIndex === index }"
      >
        <!-- 左侧背景图
            :style="{ backgroundImage: `url(${item.image})` }" -->
        <div
            class="case-img"
        >
          <img :src="item.image">
        </div>

        <!-- 右侧文字 -->
        <div class="case-content">
          <h2 class="case-title">{{ getItemTitle(item) }}</h2>
          <p class="case-desc">{{ getItemDesc(item) }}</p>
          <p v-if="getItemEffect(item)" class="case-effect">
            <strong>{{ $t('common.effect') }}：</strong>{{ getItemEffect(item) }}
          </p>
          <p v-if="getItemEvaluation(item)" class="case-evaluation">
            <strong>{{ $t('common.evaluation') }}：</strong>{{ getItemEvaluation(item) }}
          </p>
        </div>
      </div>
    </div>

    <!-- 左右箭头 -->
    <div class="arrow arrow-left" @click="prevSlide">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="#333" />
      </svg>
    </div>
    <div class="arrow arrow-right" @click="nextSlide">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="#333" />
      </svg>
    </div>

    <!-- 指示器 -->
    <div class="indicators">
      <div
          v-for="(item, index) in caseList"
          :key="index"
          class="dot"
          :class="{ active: currentIndex === index }"
          @click="goTo(index)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerCaseSlider",
  props: {
    caseList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
    };
  },
  mounted() {
    this.autoPlay();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getItemTitle(item) {
      return item.titleKey ? this.$t(item.titleKey) : item.title
    },
    getItemDesc(item) {
      return item.descKey ? this.$t(item.descKey) : item.Desc
    },
    getItemEffect(item) {
      return item.effectKey ? this.$t(item.effectKey) : item.Effect
    },
    getItemEvaluation(item) {
      return item.evaluationKey ? this.$t(item.evaluationKey) : item.Evaluation
    },
    autoPlay() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 6000);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.caseList.length;
    },
    prevSlide() {
      this.currentIndex =
          (this.currentIndex - 1 + this.caseList.length) % this.caseList.length;
    },
    goTo(index) {
      this.currentIndex = index;
      this.resetTimer();
    },
    resetTimer() {
      clearInterval(this.timer);
      this.autoPlay();
    }
  }
};
</script>

<style scoped>
.case-slider-container {
  position: relative;
  width: calc(100% - 16vh);
  padding: 0 0 50px 0;
  background: #fff;
  margin:  0 auto;
}

/* 轮播 */
.case-slider {
  position: relative;
  width: 100%;
  height: 48vh;
  overflow: hidden;
}

.case-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity 0.8s ease;
  padding: 0 60px;
  box-sizing: border-box;
  //gap: 40px;
}

.case-item.active {
  opacity: 1;
  z-index: 1;
}

/* 背景图模式：100% 100% 铺满 */
.case-img {
  width: 50%;
  height: 100%;
  background-size: 100% 100%; /* 你要的铺满 */
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  display: flex;
  align-items: center;
  >img{
    width: 100%;
    height: 100%;
  }
}

/* 右侧文字 */
.case-content {
  width: calc(50% - 16vh);
  height: calc(100% - 20vh);
  background: #F8F9FA;
  padding: 10vh 8vh;
}

.case-title {
  font-size: 1.6vw;
  font-weight: bold;
  color: #222;
  margin: 0 0 2.5vh 0;
}

.case-desc {
  font-size: 18px;
  color: #666;
  line-height: 1.8;
  margin: 0 0 16px 0;
  text-indent: 2em;
}

/* 箭头 */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 99;
}

.arrow-left {
  left: 20px;
}

.arrow-right {
  right: 20px;
}

/* 指示器 */
.indicators {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 30px;
}

.dot {
  width: 12px;
  height: 12px;
  background: #ddd;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
}

.dot.active {
  width: 30px;
  border-radius: 6px;
  background: #000;
}


</style>